import { render, staticRenderFns } from "./ocrTreatment.vue?vue&type=template&id=5ef444ee&scoped=true"
import script from "./ocrTreatment.vue?vue&type=script&lang=js"
export * from "./ocrTreatment.vue?vue&type=script&lang=js"
import style0 from "./ocrTreatment.vue?vue&type=style&index=0&id=5ef444ee&prod&scoped=true&lang=css"
import style1 from "./ocrTreatment.vue?vue&type=style&index=1&id=5ef444ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef444ee",
  null
  
)

export default component.exports